import { Chip, variables } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export interface IconButtonProps {
  borderColor?: string;
  bgColor?: string;
  hoverColor?: string;
  width?: string;
  height?: string;
}
export const StatusLabel = styled(({ bgColor, textColor, hoverColor, ...props }) => <Chip {...props} />)`
  &.MuiChip-root {
    background-color: ${({ bgColor }) => (bgColor ? bgColor : 'light-gray')} !important;
    color: ${({ textColor }) => (textColor ? variables.color[textColor] : variables.color.secondaryText)} !important;
    &:hover {
      background-color: ${({ hoverColor }) => (hoverColor ? hoverColor : 'light-gray')} !important;
    }
  }
`;

export const DotContainer = styled.div`
  display: flex;
  align-items: end;
  justify-content: center;
  width: 25px;
  top: 0;
  bottom: 0;
  background-color: transparent;
  cursor: pointer;
`;

export const Circle = styled.div<IconButtonProps>`
  align-items: center;
  display: flex;
  justify-content: center;
  width: ${(props) => props.width || '25px'};
  height: ${(props) => props.height || '25px'};
  padding: 6px;
  background-color: ${(props) => props.bgColor || 'none'};
  border: ${(props) =>
    props.borderColor ? `1px solid ${props.borderColor}` : `1px solid ${props.bgColor || 'inherit'}`};
  border-radius: 50%;

  svg {
    color: ${(props) => props.borderColor || 'inherit'};
    width: ${(props) => props.width || '25px'};
    height: ${(props) => props.height || '25px'};
  }
  &:hover {
    background-color: ${({ hoverColor }) => (hoverColor ? hoverColor : 'light-gray')};
  }
`;
